import { MessagesType, AuthUserType } from "../../Actions/Types"
import { Reducer } from "redux"
import { UserAction } from "../Auth/UserReducer"

export enum MessageSentiment {
    good = "GOOD",
    warn = "WARN",
    bad = "BAD"
}

export interface IMessagesState {
    id: number
    text: string
    type: MessageSentiment
}

export interface MessagesState {
    current: IMessagesState | undefined
}

interface MessagesSetAction {
    type: MessagesType.set
    payload: {
        text: string
        type: MessageSentiment
    }
}

export type MessagesAction = MessagesSetAction

const initialState: MessagesState = {
    current: undefined
}

export const MessagesReducer: Reducer<
    MessagesState,
    MessagesAction | UserAction
> = (state = initialState, action): MessagesState => {
    switch (action.type) {
        case MessagesType.set:
            return {
                ...state,
                current: {
                    id: state.current === undefined ? 0 : state.current.id + 1,
                    ...action.payload
                }
            }
        case AuthUserType.signedOut:
            return initialState
        default:
            return state
    }
}
